import { ConfigData } from '../config/StoreLocatorTextResources';

export class LocalStorageService {
  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/Storage
   */
  addLocationKeyToLocalStorage(location: object) {
    const keyaccount = location['keyacc_id'] ? location['keyacc_id'] : ConfigData.data['keyaccount'];
    const lastSelectedLocation = 'co.' + keyaccount + '.LAST_SELECTED_LOCATION_ON_SITE';
    const lastLocation = 'co.' + keyaccount + '.LAST_LOCATIONS_ON_SITE';
    const locationItem = this.createItemObject(location);

    localStorage.setItem(lastSelectedLocation, JSON.stringify(locationItem));
    localStorage.setItem(lastLocation, JSON.stringify([locationItem]));
  }

  createItemObject(location: object) {
    const itemObj = {
      id: location['loc_id'],
      name: location['name'],
      zip: location['zip'],
      city: location['city'],
      street: location['street'],
      longitude: location['longitude'],
      latitude: location['latitude'],
      shopRef: location['shop_ref'],
      availableOnSiteArticleInfos: this.createArticleInfos(location['onsite_prints']),
      apex: false,
    };

    return itemObj;
  }

  createArticleInfos(products: string) {
    const regexp = /[0-9]*/g;
    const matches = products.matchAll(regexp);
    const artikles = [];

    for (const match of matches) {
      if (match[0].length > 0) {
        const item = {
          articleId: match[0],
          mainGroup: 'prints',
        };

        artikles.push(item);
      }
    }

    return artikles;
  }
}

export const LOCALSTORAGE = new LocalStorageService();
